import React, { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import moment from "moment-timezone";
import {
  ButtonRow,
  ContainerDaily,
  Label,
  Value,
  TitleSection,
  HeadListTask,
  EditButton,
  DeleteButton,
  ValueWithBack,
  ValueRow,
} from "./workingPartDetail.styled";
import { converToTime } from "../../../../utils/formats/number";
import { Can, AbilityContext } from "../../../security/permissions/Can";
import { USER_PERMISSIONS } from "../../../security/permissions/rolesPermission";
import { PART_STATUS } from "../../../../constants/index";

const DailyPartDetailView = (props) => {
  const { t } = useTranslation();
  const context = useContext(AbilityContext);

  const {
    dailyPart,
    onUpdatePart,
    onDeletePart,
    onCreatePart,
    onBack,
    validatePart,
    confirmPart,
    isValidate,
    isConfirmed,
    isTechnical,
  } = props;
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.workingPart.list"), path: PATHS.MY_WORKING_PART_LIST },
    {
      label: `${t("forms.workingPart.detail")}: ${
        dailyPart?.user.completeName ? dailyPart.user.completeName : ""
      }`,
    },
  ];

  let status = "";

  if (dailyPart) {
    status = PART_STATUS.find((st) => st.code === dailyPart.status);
  }
  const renderRows = (rows) => {
    return rows.map((row) => {
      return <ValueRow key={`row_${row}`}>{`${t("row")} ${row}`}</ValueRow>;
    });
  };

  const renderTasks = () => {
    return dailyPart.parts.map((part, index) => {
      return (
        <div className="accordion-item" key={part.uuid}>
          <div className="accordion-header">
            <ButtonRow
              className="accordion-button task collapsed"
              // type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#part-${part.uuid}`}
              aria-expanded="false"
              aria-controls={`part-${part.uuid}`}
            >
              <div className="row no-margin align-items-center">
                <div className="col-3 col-md-1 text-center px-0">
                  {moment(part.initTime).format("kk:mm")}
                </div>
                <div className="col-3 col-md-1 text-center px-0">
                  {moment(part.endTime).format("kk:mm")}
                </div>
                <div className="col-3 col-md-2 text-center px-0">
                  {converToTime(part.taskTime)}
                </div>
                <div className="col-3 col-md-1 text-center px-0">
                  {part.code.code}
                </div>
                <div className="col-5 d-none d-md-block">{part.task.name}</div>
                <div className="col-5 col-md-2 d-flex justify-content-end align-items-center d-none d-md-block text-end">
                  {((isTechnical && !isValidate && !isConfirmed) ||
                    (!isTechnical && !isConfirmed)) && (
                    <>
                      <EditButton
                        type="button"
                        className="me-2"
                        onClick={() => onUpdatePart(part)}
                      >
                        <i className="fa-solid fa-file-pen"></i>
                      </EditButton>
                      <DeleteButton
                        type="button"
                        onClick={() => onDeletePart(part)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </DeleteButton>
                    </>
                  )}
                </div>
              </div>
            </ButtonRow>
          </div>
          <div
            id={`part-${part.uuid}`}
            className="accordion-collapse collapse"
            data-bs-parent="#dailyTasks"
          >
            <div className="accordion-body task">
              <div className="row">
                <div className="col-4 col-md-2 d-flex flex-column">
                  <Label>{t("forms.workingPart.labels.batch")}</Label>
                  <Value>{part.code.batch.code}</Value>
                </div>
                <div className="col-4 col-md-2 d-flex flex-column">
                  <Label>{t("forms.workingPart.labels.culture")}</Label>
                  <Value>{part.code.culture}</Value>
                </div>
                <div className="col-4 col-md-2 d-flex flex-column">
                  <Label>{t("forms.workingPart.labels.variety")}</Label>
                  <Value>{part.code.variety.name}</Value>
                </div>
                <div className="col-12 col-md-3 d-flex flex-column mt-2 mt-md-0">
                  <Label>{t("forms.workingPart.labels.article")}</Label>
                  <Value>
                    {`${part.code.article.name} (${part.code.article.description})`}
                  </Value>
                </div>
                <div className="col-12 col-md-2 d-flex flex-column mt-2 mt-md-0">
                  <Label>{t("forms.workingPart.labels.numPlants")}</Label>
                  <Value>{`${part.numPlants}`}</Value>
                </div>
                <div className="col-12 col-md-2 d-flex flex-column mt-2 mt-md-0 d-block d-md-none">
                  <Label>{t("forms.workingPart.labels.task")}</Label>
                  <Value>{`${part.task.name}`}</Value>
                </div>
              </div>
              <div className="row mt-2 mt-md-3">
                <div className="col-5 col-md-2 d-flex flex-column">
                  <Label>{t("forms.workingPart.labels.partNight")}</Label>
                  <Value>
                    <ValueWithBack>{`${
                      part.isNight ? "Si" : "No"
                    }`}</ValueWithBack>
                  </Value>
                </div>
                <div className="col-7 col-md-2 d-flex flex-column">
                  <Label>{t("forms.workingPart.labels.location")}</Label>
                  <Value>{`${part.code.location.name}`}</Value>
                </div>
                <div className="col-6 col-md-2 d-flex flex-column mt-2 mt-md-0">
                  <Label>{t("forms.workingPart.labels.sector")}</Label>
                  <Value>{`${
                    part.code.sector ? part.code.sector.name : "-"
                  }`}</Value>
                </div>
                <div className="col-6 col-md-6 d-flex flex-column mt-2 mt-md-0">
                  <Label>{t("forms.workingPart.labels.rows")}</Label>
                  <Value>{renderRows(part.rows)}</Value>
                </div>
              </div>
              {part.comments && (
                <div className="row mt-2 mt-md-3">
                  <div className="col-12 d-flex flex-column">
                    <Label>{t("forms.workingPart.labels.comments")}</Label>
                    <Value>{`${part.comments}`}</Value>
                  </div>
                </div>
              )}
              <div className="row mt-4 d-block d-md-none">
                <div className="col-12 d-flex justify-content-end align-items-center">
                  {((isTechnical && !isValidate && !isConfirmed) ||
                    (!isTechnical && !isConfirmed)) && (
                    <>
                      <EditButton
                        type="button"
                        className="me-2"
                        onClick={() => onUpdatePart(part)}
                      >
                        <i className="fa-solid fa-file-pen"></i>
                      </EditButton>
                      <DeleteButton
                        type="button"
                        onClick={() => onDeletePart(part)}
                      >
                        <i className="fa-solid fa-trash-can"></i>
                      </DeleteButton>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{`${t("forms.workingPart.detail")}: ${
            dailyPart?.user.completeName ? dailyPart.user.completeName : ""
          }`}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center mb-4 mt-3">
        <div className="col-12 col-md-11">
          <ContainerDaily>
            <div className="row align-items-center">
              <div className="col-6 col-md-2 d-flex flex-column">
                <Label>{t("forms.workingPart.labels.date")}</Label>
                <Value>
                  {dailyPart
                    ? moment(dailyPart?.date).format("DD-MM-yyyy")
                    : ""}
                </Value>
              </div>
              <div className="col-6 col-md-2 d-flex flex-column">
                <Label>{t("forms.workingPart.labels.totalTime")}</Label>
                <Value>
                  {dailyPart ? converToTime(dailyPart?.totalTime) : ""}
                </Value>
              </div>
              <div className="col-12 col-md-2 d-flex flex-column mt-2 mt-md-0">
                <Label>{t("forms.workingPart.labels.status")}</Label>
                <Value>{t(status.label)}</Value>
              </div>
              <div className="col-6 text-end">
                {!isTechnical && !isValidate && !isConfirmed && (
                  <Can do={USER_PERMISSIONS.PART_VALIDATE}>
                    <button
                      type="button"
                      className="btn btn-md btn-danger"
                      onClick={() => validatePart()}
                    >
                      {t("forms.workingPart.buttons.validate")}
                    </button>
                  </Can>
                )}
                {!isTechnical && isValidate && !isConfirmed && (
                  <Can do={USER_PERMISSIONS.CONFIRM_PART}>
                    <button
                      type="button"
                      className="btn btn-md btn-danger"
                      onClick={() => confirmPart()}
                    >
                      {t("forms.workingPart.buttons.confirm")}
                    </button>
                  </Can>
                )}
              </div>
            </div>
          </ContainerDaily>
        </div>
      </div>

      <div className="row justify-content-center mt-5 mb-5 ">
        <div className="col-12 col-md-11">
          <ContainerDaily>
            <div className="row">
              <TitleSection className="col-12 mb-4">
                {t("forms.workingPart.taskList")}
              </TitleSection>
            </div>
            {dailyPart && (
              <>
                <div className="row no-margin ">
                  <HeadListTask className="col-3 col-md-1 text-center px-0">
                    {t("forms.workingPart.labels.initTime")}
                  </HeadListTask>
                  <HeadListTask className="col-3 col-md-1 text-center px-0">
                    {t("forms.workingPart.labels.endTime")}
                  </HeadListTask>
                  <HeadListTask className="col-3 col-md-2 text-center">
                    {t("forms.workingPart.labels.taskTime")}
                  </HeadListTask>
                  <HeadListTask className="col-3 col-md-1 text-center">
                    {t("forms.workingPart.labels.code")}
                  </HeadListTask>
                  <HeadListTask className="col-5 col-md-5 d-none d-md-block">
                    {t("forms.workingPart.labels.task")}
                  </HeadListTask>
                  <HeadListTask className="col-5 col-md-2 d-none d-md-block"></HeadListTask>
                </div>

                <div className="row no-margin">
                  <div className="col-12 px-0 pb-4">
                    <div className="accordion accordion-flush" id="dailyTasks">
                      {renderTasks()}
                    </div>
                  </div>
                </div>
              </>
            )}
          </ContainerDaily>
        </div>
      </div>
      <div className="row justify-content-center mt-4">
        <div className="col-12 col-md-11 d-flex justify-content-center">
          <button
            className="btn btn-primary btn-md me-3"
            onClick={() => onBack()}
          >
            {t("forms.workingPart.buttons.back")}
          </button>
          <button
            className="btn btn-secondary btn-md "
            onClick={() => onCreatePart()}
          >
            {t("forms.workingPart.buttons.new")}
          </button>
        </div>
      </div>
    </>
  );
};

DailyPartDetailView.propTypes = {};

export default DailyPartDetailView;
